import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Translators } from '../../../services/shared/translators.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TermsOfServiceComponentHome } from './terms-of-service-home/terms-of-service-home.component';
import { User } from '@interfaces/interface-bakend/seguridad/users/user.interface';
import { AuthService } from '@services/auth/auth.service';
import { DetectarDispositivoService } from '@services/detectar-dispositivo/detectar-dispositivo.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {

  idioma: Subscription;
  flagTitular = false;

  // URLs de descarga
  private readonly URL_IOS = 'https://apps.apple.com/ar/app/signo-medico-osoetsylra/id6747086964';
  private readonly URL_ANDROID = 'https://play.google.com/store/apps/details?id=io.cipbyte.signomedico&hl=es_AR';

  ////
  showAppModal = false;
  
  constructor(
      private translatorService: Translators,
      private router: Router,
      public dialog: MatDialog,
      private authService: AuthService,
      private dispositivoService: DetectarDispositivoService
  ) {
    this.idioma = this.translatorService.getIdiomaSeleccionado().subscribe(resp => {
      this.idioma = resp;
    });

  }

  async ngOnInit() {
    this.flagTitular = await this.titular();
    await this.verificarAfiliadoWeb();
  }

  async verificarAfiliadoWeb(): Promise<void> {
    const user = await this.authService.getUserLogon();
    
    // Verificar si el usuario tiene el ID específico
    if (user && user.perfil._id === '65dccf7ac186b433577b3aef') {
      // Pequeño delay para mejor UX (esperar a que cargue la página)
      setTimeout(() => {
        this.showAppModal = true;
      }, 500);
    }
  }

  openDialog() {
    this.dialog.open(TermsOfServiceComponentHome,{
      disableClose: true
    });
  }

  refreshHome() {
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/']);
    });
  }

  async titular(): Promise<boolean> {
    const afiliadoLogged = await this.authService.getUserLogon();
    return afiliadoLogged?.signoGecrosAfiliado?.parentesco === 'TITULAR';
  }

  closeAppModal(): void {
    this.showAppModal = false;
  }

  redirectToAppStore(): void {
    // Primero verificamos si es dispositivo móvil
    const esMovil = this.dispositivoService.isAndroid() || this.dispositivoService.isIOS();
    
    if (!esMovil) {
      // Dispositivo no móvil (escritorio) - redirige a Android
      window.location.href = this.URL_ANDROID;
    } else {
      // Dispositivo móvil - detectamos específicamente
      if (this.dispositivoService.isAndroid()) {
        window.location.href = this.URL_ANDROID;
      } else if (this.dispositivoService.isIOS()) {
        window.location.href = this.URL_IOS;
      } else {
        // Por si acaso, cualquier otro móvil va a Android
        window.location.href = this.URL_ANDROID;
      }
    }
    
    // Cerrar la modal después de redirigir
    this.closeAppModal();
  }

}


